// extracted by css-extract-rspack-plugin
export default {"label":"label-CWnrur","value":"value-e06fN1","input":"input-Pol3w5"};